import { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { Menu, MenuItem } from "@mui/material";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDBadge from "components/MDBadge";
import Breadcrumbs from "examples/Breadcrumbs";
import { Badge, Chip } from "@mui/material";
import NotificationItem from "examples/Items/NotificationItem";
import Footer from "examples/Footer";
import { Settings, HelpOutline } from "@mui/icons-material";
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";
import { AccountCircle, ExitToApp } from "@mui/icons-material";
import NotificationsIcon from '@mui/icons-material/Notifications';

import { Box, Typography, Divider, Button } from '@mui/material';
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarDesktopMenu,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Route to Title Mapping
const routeTitleMap = {
  'carecoordinatorsdetails': 'Care Coordinators Details',
  'dashboard': 'Dashboard',
  'location': 'Location',
  'notification': 'Notifications',
  'profile': 'Profile',
  'security': 'Security',
  'settings': 'Settings',
  'devicemapping': 'Device Mapping',
  'dpmapping': 'DP Mapping',
  // Add more routes as needed
};

// Function to get formatted title from route
const getPageTitle = (routeString) => {
  // First check if we have a mapped title
  if (routeTitleMap[routeString.toLowerCase()]) {
    return routeTitleMap[routeString.toLowerCase()];
  }
  
  // If no mapping exists, format the route string automatically
  return routeString
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Handle camelCase
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') // Handle PascalCase
    .replace(/[-_]/g, ' ') // Handle kebab-case and snake_case
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

function DashboardNavbar({ absolute, light, isMini, notificationCount = 0 }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
  const route = useLocation().pathname.split("/").slice(1);
  const [notifications, setNotifications] = useState([]);
  const unreadCount = notifications.filter((n) => !n.read).length;
  const navigate = useNavigate();
const loginData = JSON.parse(localStorage.getItem("loginData"));

const name = `${loginData?.firstName || ""} ${loginData?.lastName || ""}`.trim();
const role = loginData?.role || "";
const username = loginData?.username || "";

  // Get formatted page title
  const pageTitle = route.length > 0 ? getPageTitle(route[route.length - 1]) : 'Dashboard';

  // Move removeData function here
  const removeData = () => {
    try {
      localStorage.removeItem("loginData");
      navigate("/");
    } catch (error) {
      console.log("Error logging out:", error);
    }
  };

  useEffect(() => {
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    window.addEventListener("scroll", handleTransparentNavbar);
    handleTransparentNavbar();
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  const handleProfileMenuOpen = (event) => setProfileMenuAnchor(event.currentTarget);
  const handleProfileMenuClose = () => setProfileMenuAnchor(null);



const handleHomeNavigation = () => {
  if (role === "ROLE_SUPER") {
    navigate("/SuperDashboard", { replace: true });
  } else if (role === "ROLE_CARE_COORDINATOR") {
    navigate("/dashboard", { replace: true });
  } else if (role === "ROLE_DOCTOR") {
    navigate("/DoctorDashboard", { replace: true });
  } else if (role === "ROLE_USER") {
    navigate("/PatientDashboard", { replace: true });
  } else {
    navigate("/dashboard", { replace: true });
  }
};







  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      MenuListProps={{
        onMouseLeave: handleCloseMenu,
      }}
      PaperProps={{
        sx: {
          width: 280,
          borderRadius: 2,
          mt: 1.5,
          boxShadow: 3,
          overflow: 'hidden',
        },
      }}
    >
      <Box sx={{ backgroundColor: '#2e7faeff', px: 2, py: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Icon sx={{ color: '#000000' }}>notifications_active</Icon>
        <Typography variant="subtitle1" sx={{ color: '#000000', fontWeight: 'bold' }}>
          Alerts
        </Typography>
      </Box>


      {/* View All Button */}
      <Box sx={{ px: 2, py: 1, textAlign: 'right' }}>
        <Button
          variant="text"
          sx={{ color: '#success', textTransform: 'none', fontWeight: 'bold' }}
          endIcon={<Icon>arrow_forward</Icon>}
          onClick={() => {
            handleCloseMenu();
            navigate("/notification");
          }}
        >
          VIEW ALL
        </Button>
      </Box>
    </Menu>
  );

  const renderProfileMenu = () => (
    <Menu
      anchorEl={profileMenuAnchor}
      open={Boolean(profileMenuAnchor)}
      onClose={handleProfileMenuClose}
      MenuListProps={{
        onMouseLeave: handleProfileMenuClose,
      }}
      sx={{ mt: 2 }}
    >
      <MenuItem onClick={handleProfileMenuClose}>
        <Link to="/profile" style={{ textDecoration: "none", color: "inherit", display: "flex", alignItems: "center" }}>
          <AccountCircle style={{ marginRight: 8, fontSize: 20 }} />
          Profile
        </Link>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuClose}>
        <Link to="/security" style={{ textDecoration: "none", color: "inherit", display: "flex", alignItems: "center" }}>
          <Settings style={{ marginRight: 8, fontSize: 20 }} />
          Settings
        </Link>
      </MenuItem>

      <Divider />
      
      <MenuItem onClick={removeData}>
        <Link to="/" style={{ textDecoration: "none", color: "inherit", display: "flex", alignItems: "center" }}>
          <ExitToApp style={{ marginRight: 8, fontSize: 20 }} />
          Logout
        </Link>
      </MenuItem>
    </Menu>
  );

  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;
      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }
      return colorValue;
    },
  });

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
    <Box>
      <Typography
        variant="body2"
        sx={{ fontWeight: 600, lineHeight: 1.2 ,fontWeight: 600,          // bold
    color: "#1a1b1cff",         // dark blue (change if needed)
   }}
      >
        {name ? name : username}

      </Typography>
     <Typography
  variant="caption"
  sx={{
    opacity: 0.9,
    fontWeight: 600,          // bold
    color: "#1a1b1cff",       // dark blue
    fontSize: "0.75rem",
  }}
>
  {role
    ?.split(",")
    .map(r => {
      switch (r) {
        case "ROLE_USER":
          return "Patient";
        case "ROLE_SUPER":
          return "Super_Admin";
        default:
          // fallback: remove ROLE_ and format nicely
          return r.replace("ROLE_", "").toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
      }
    })
    .join(", ")}
</Typography>




    </Box>
  </Box>
        <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          {/* <Breadcrumbs icon="home" title={pageTitle} route={route} light={light} /> */}
        </MDBox>
        {!isMini && (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            <MDBox color={light ? "white" : "inherit"}>
              {renderProfileMenu()}
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>
              
              <IconButton
                size="medium"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                onClick={() => {
                  handleMiniSidenav();
                  handleHomeNavigation();
                }}
              >
                <Icon sx={iconsStyle}>home</Icon>
              </IconButton>
              <IconButton
                size="medium"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                onClick={handleOpenMenu}
              >
                <Badge badgeContent={notificationCount} color="error">
                  <NotificationsIcon />
                </Badge>
              </IconButton>

              <div
                onMouseEnter={handleProfileMenuOpen}
                style={{ display: "inline-block", cursor: "pointer" }}
              >
                <IconButton sx={navbarIconButton} size="medium" disableRipple>
                  <Icon sx={iconsStyle}>account_circle</Icon>
                </IconButton>
              </div>
              {renderMenu()}
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
  notificationCount: PropTypes.number,
};

export default DashboardNavbar;